import { React, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
export const InputFormList = ({
  label,
  placeholder,
  id,
  disabled,
  hidden,
  filter,
  list = [],
  propertyId,
  propertyName,
  value = "",
  handleChange,
  required,
  isInvalid,
}) => {
  return (
    <Row className="mb-2" hidden={hidden(filter, label)}>
      <Col xs={12} md={5}>
        <Form.Label
          hidden={hidden(filter, label)}
          style={{ fontSize: "0.875rem" }}
        >
          {label}
        </Form.Label>
      </Col>
      <Col xs={12} md={7}>
        <Form.Select
          required={required}
          placeholder={placeholder}
          id={id}
          disabled={disabled()}
          value={value !== false && value !== 0 ? value || "" : value}
          hidden={hidden(filter, label)}
          onChange={(e) => handleChange(id, e.target.value)}
          size="sm"
          isInvalid={isInvalid}
        >
          <option value="">-Seleccionar-</option>
          {list !== undefined &&
            list.length > 0 &&
            list
              .filter((field) => field[propertyId] !== null)
              .map((field, index) => (
                <option key={index} value={field[propertyId]}>
                  {field[propertyName]}
                </option>
              ))}
        </Form.Select>
        <Form.Control.Feedback type="invalid">
          El {label} es necesario.
        </Form.Control.Feedback>
      </Col>
    </Row>
  );
};
